import { render, staticRenderFns } from "./selection.vue?vue&type=template&id=a6b7f192&scoped=true"
import script from "./selection.vue?vue&type=script&lang=js"
export * from "./selection.vue?vue&type=script&lang=js"
import style0 from "./selection.vue?vue&type=style&index=0&id=a6b7f192&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b7f192",
  null
  
)

export default component.exports